import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import categoriesData from '../../functions/Categories.json';
import '../../styles/Home/homeCategories.css';
import { db } from '../../firebase';
import { doc, getDoc } from 'firebase/firestore';

const ExploreWorldCategories = () => {
  const cardsContainerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [bannerImage, setBannerImage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Fetch Explore World banner image from Firestore
  useEffect(() => {
    async function fetchBannerImage() {
      try {
        const docRef = doc(db, "Images", "AllImages");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists() && docSnap.data()["Explore World"] && docSnap.data()["Explore World"].url) {
          setBannerImage(docSnap.data()["Explore World"].url);
        }
      } catch (error) {
        // fallback: do nothing
      }
    }
    fetchBannerImage();
  }, []);

  const scrollLeft = () => {
    if (cardsContainerRef.current) {
      cardsContainerRef.current.scrollLeft -= 250;
    }
  };

  const scrollRight = () => {
    if (cardsContainerRef.current) {
      cardsContainerRef.current.scrollLeft += 250;
    }
  };

  const handleCardClick = (location) => {
    const destinationKey = location.toLowerCase().replace(/\s+/g, '');
    window.scrollTo(0, 0);
    navigate(`/destinations/${destinationKey}`);
  };

  return (
    <div className="category-outer-container explore-world-outer">
      <div className="category-container">
        <div
          className="category-banner"
          style={{
            backgroundImage: bannerImage
              ? `url('${bannerImage}')`
              : "url('https://miro.medium.com/v2/resize:fit:1400/1*GpyC3BaginCXOqaFP45EJw.jpeg')"
          }}
        >
          <div className="category-banner-content">
            <h1 className="category-banner-h1" style={{ fontSize: isMobile ? '1.8em' : '2.5em' }}>Explore World</h1>
            <p className="category-banner-p">Discover Continents, Cultures, and Wonders</p>
            <a
              href="#"
              className="category-explore-button"
              style={{ backgroundColor: '#afc15a', color: '#333' }}
              onClick={(e) => {
                e.preventDefault();
                navigate('/trips?q=international');
                window.scrollTo(0, 0);
              }}
            >
              Explore
            </a>
          </div>
        </div>
      </div>

      <button
        className="nav-arrow nav-left"
        onClick={scrollLeft}
        aria-label="Scroll left"
      >
        <span className="arrow-icon" style={{ backgroundColor: '#afc15a' }}>
          <i className="fas fa-chevron-left"></i>
        </span>
      </button>

      <button
        className="nav-arrow nav-right"
        onClick={scrollRight}
        aria-label="Scroll right"
      >
        <span className="arrow-icon" style={{ backgroundColor: '#afc15a' }}>
          <i className="fas fa-chevron-right"></i>
        </span>
      </button>

      <div className="category-cards-overlay" ref={cardsContainerRef}>
        {categoriesData.International.filter(dest => dest.img && dest.price).map((destination, index) => (
          <div
            key={index}
            className="destination-card"
            onClick={() => handleCardClick(destination.name)}
            role="button"
            tabIndex={0}
          >
            <img src={destination.img} alt={destination.name} className="destination-card-img" />
            <h3 style={{
              marginTop: 0,
              marginBottom: '5px',
              fontSize: '1.1em',
              color: 'white',
              textShadow: '1px 1px 3px rgba(0,0,0,0.7)'
            }}>{destination.name}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExploreWorldCategories;


